module.exports = __webpack_public_path__ + "static/media/medium-rare.328a1d9a.png";